import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ISolicitudModel } from 'src/app/models/interfaces/ISolicitudModel';

@Component({
  selector: 'app-solicitud-master-readonly',
  templateUrl: './solicitud-master-readonly.component.html',
  styleUrls: ['./solicitud-master-readonly.component.css']
})
export class SolicitudMasterReadonlyComponent implements OnInit {

  @Input() model!: ISolicitudModel;  
  constructor(
  ) { 
  }

  ngOnInit(): void {
  }
}
